$(document).ready(function () {
   $(".offer-item").click(function(){
    $(".offer-item").removeClass("active")
    $(this).addClass("active");
    var data_code = $(this).attr("data-code");
    $(".offer-item-code").hide();
    $(".offer-item-code[data-title-code='"+data_code+"']").show();
});
$(".offer-title-slider").slick({
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows:false
})

// copy code functionality
$(document).on("click", ".copy-btn", function (e) {
  e.stopPropagation(); // prevent triggering parent click
  var code = $(this).closest(".offer-item-code").data("title-code");

  // copy to clipboard
  var temp = $("<input>");
  $("body").append(temp);
  temp.val(code).select();
  document.execCommand("copy");
  temp.remove();

  // feedback
  var btn = $(this);
  btn.text("Copied!");
  setTimeout(function () {
    btn.html(`
  <svg class="prod_off-copy-button-icon-ang5uu1pxwwt5l0l6nproductoffersludfdi prod_off-copy-button-icon" 
       xmlns="http://www.w3.org/2000/svg" 
       viewBox="0 0 24 24" 
       fill="none" 
       stroke="currentColor" 
       stroke-width="2" 
       stroke-linecap="round" 
       stroke-linejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
  </svg>
  Copy code
`);
  }, 2000);
});
  $(".thumbnail-vertical-slider .thumbnail-list").slick({
    vertical: true,
    slidesToShow: 4,
    infinite: false,
    responsive: [
        {
            breakpoint: 749,
            settings: {
                vertical: false,
                slidesToShow: 4,
                arrows: true
            }
        }
    ]
});
  Fancybox.bind("[data-fancybox]", {
    // your custom options from (https://fancyapps.com/fancybox/api/options)
  });

  $(
    ".collage-home-wrapper .block-content2,.collage-home-wrapper .block-content3"
  ).wrapAll('<div class="middle-block-wrapp"></div>');

  $(".block-content-wrapp video").each(function () {
    this.pause();
  });
  $(document).on("click", ".has_video__block", function () {
    var $el = $(this),
      video = $el.find("video").get(0);

    $("video").each(function () {
      if (this !== video) {
        this.pause();
        $(this).closest(".has_video__block").removeClass("video-play");
      }
    });

    if (video.paused) {
      video.play();
      $el.addClass("video-play");
    } else {
      video.pause();
      $el.removeClass("video-play");
    }
  });
setTimeout(function(){
$(".tab-title[data-index='1']").click();
    },900);
  $(document).on("click", ".tab-title", function () {
    $(".tab-title").removeClass("active");
  
    $(this).addClass("active");
    var index = $(this).attr("data-index"),
      target= $(this).attr("data-target"),
      __class = $(this).attr("data-class");
    $(".featured-slider").hide().removeClass("active");
    $(".featured-slider.tabcontent-" + index)
      .show()
      .addClass("active");
    $(".home-tab-slider").slick('slickUnfilter');
    $(".home-tab-slider").slick('slickFilter', '.'+target);
    $()
      $('.home-tab-slider').attr('data-class',__class);
  });

  
  $(".home-tab-slider").slick({
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".testimonial-block-content").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    dots: false,
    centerPadding: "0",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".js-collection-slider").each(function () {
    var $slider = $(this),
      desk_data = parseInt($slider.attr("data-desk-item")) || 3,
      mob_data = parseInt($slider.attr("data-mob-item")) || 1;

    $slider.slick({
      slidesToShow: desk_data,
      slidesToScroll: 1,
      speed: 500,
      dots: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: desk_data,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: mob_data,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: mob_data,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });

  $(".js-pdp-collection-slider").each(function () {
    var $slider = $(this),
      desk_data = parseInt($slider.attr("data-desk-item")) || 3,
      mob_data = parseInt($slider.attr("data-mob-item")) || 1;
    $slider.slick({
      slidesToShow: desk_data,
      slidesToScroll: 1,
      speed: 500,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: desk_data,
            slidesToScroll: 1,

            infinite: true,
            centerMode: true,
            centerPadding: "0",
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: mob_data,
            slidesToScroll: 1,
            infinite: false,
            centerMode: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: mob_data,
            slidesToScroll: 1,
            infinite: false,
            centerMode: false,
          },
        },
      ],
    });
  });

  $(".iwt-block-content").slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  });

  if ($(window).width() < 767) {
    $(".js-articles-wrapper").slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }

  var highestBox = 0;
  $(".card-wrapper").each(function () {
    if ($(this).height() > highestBox) {
      highestBox = $(this).height();
    }
  });
  $(".product-collage-media").height(highestBox);

  $(document).on(
    "change",
    ".items__availibility input[type='checkbox']",
    function () {
      if (
        $(".items__availibility input[name='filter.v.availability']:checked")
          .length
      ) {
        console.log("treee");
        $(this).addClass("active");
      } else {
        $(this).removeClass("active");
      }
    }
  );

  // abut us slick slider arrow wrapp in a div
  $(".iwt-block-content .slick-prev, .iwt-block-content .slick-next").wrapAll(
    "<div class='button-wrapper'></div>"
  );

  $(document).on("click", ".card_addtocart", function (e) {
    e.preventDefault();
    var $this = $(this),
      vid = $this.attr("data-id"),
      rmvdata = [],
      data = [];
    cartJSON().then((cart) => {
      var f_item = cart.items.filter((item) => item.variant_id == vid);
      console.log(cart, "<<<<< cart", f_item, vid);
      if (f_item?.length) {
        rmvdata.push(`${f_item[0].key}|0`);
        removeItems(rmvdata);
      } else {
        data.push({
          id: vid,
          quantity: 1,
          properties: {},
        });
        multipleATC(data);
      }
    });
  });

  $(document).on("click", ".js_menu__preorder", function (e) {
    e.preventDefault();
    $(".menu-preorder__form-wrapp").show();
  });

  // megamenu hover images
 $(".header__menu-item[data-image-url]").hover(
  function () {
    const wrapper = $(this).closest(".mega_linklist_wrapper");

    wrapper.find(".menu-img")
      .attr("src", $(this).attr("data-image-url"))
      .attr("srcset", $(this).attr("data-image-url"));

    wrapper.find(".view_btn.btnlink").attr("href", $(this).attr("href"));
  },
  function () {}
);

$(".header__menu-item[data-image-url]").first().trigger("mouseenter");

$(".megamenu-image-link[data-image-url]").hover(
  function () {
    const wrapper = $(this).closest(".mega_images_wrapper");

    wrapper.find(".hover-menu-img")
      .attr("src", $(this).attr("data-image-url"))
      .attr("srcset", $(this).attr("data-image-url"));

    // wrapper.find(".view_btn.btnlink").attr("href", $(this).attr("href"));
  },
  function () {}
);

$(".megamenu-image-link[data-image-url]").first().trigger("mouseenter");


  $(document).on("click", ".preorder-button-wrapp", function () {
    var $_this = $(this),
      prod_name = $_this.attr("data-product-name");

    console.log(prod_name);

    setTimeout(function () {
      $(".preorder-prod-title").val(prod_name);
    }, 1000);

    $(".preorder-form-wrapper").show();
  });

  $(document).on("click", ".close-btn-wrapp", function () {
    $(".preorder-form-wrapper").hide();
    $(".menu-preorder__form-wrapp").hide();
  });
  function displayPreviewModal() {
    $("#pop-ups").css("display", "block");
    $("body").addClass("popup-model-opened");
    $(".home-popup").addClass("active");
  }
  function hidePreviewModal() {
    $("#pop-ups").css("display", "none");
    $("body").removeClass("popup-model-opened");
    $(".home-popup").removeClass("active");
  }
  $(document).on("click", ".prerview-close-btn", function () {
    hidePreviewModal();
  });
  $(document).on("click", ".product__accordion-wrap", function () {
    console.log("clicked");
    $(this).addClass("show");
    $(this).find(".upper__product_accordion details").css({
      "pointer-events": "none",
    });
    displayPreviewModal();
  });
  $(window).on("click", function (e) {
    if (e.target.id == "pop-ups") {
      hidePreviewModal();
    }
    if (e.target.id == "pop-ups") {
      modal("#pop-ups", false);
    }
  });

  $(document).on("click", ".sorting_custom .selected_opt", function (event) {
    $(this).toggleClass("active");
    $(this).next().slideToggle();
  });

  $(document).on("hover", function (event) {
    if (!$(event.target).closest(".sorting_custom").length) {
      $(".sorting_custom .selected_opt").removeClass("active");
      $(".sorting_custom .sort_ul").slideUp();
    }
  });

  $(document).on("click", ".sort_item", function () {
    var __this = $(this),
      selectedValue = __this.data("value"),
      selectedText = __this.text();
    $(".selected_opt").text(selectedText);
    console.log("ffff", selectedText, selectedValue);
    __this
      .closest(".sort_by__wrapper")
      .find('[name="sort_by"]')
      .val(selectedValue);
    __this.closest("form").submit();
    $(".sort_item").removeClass("selected");
    __this.addClass("selected");
  });


// mobile menu navigation
  $(document).on('click','.first-level-link', function(){
    var __this = $(this),
      closest = __this.closest('.first-level-item');
    $(this).next('ul').slideToggle();
    $(this).toggleClass('open');
    closest.toggleClass('open_first_level');
});
  
}); //ready

const cartJSON = () => {
  return fetch("/cart.js").then((r) => r.json());
};

window.refreshCart = () => {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      console.log("html ", html);
      const count = parseInt(
        html.querySelector("cart-drawer-items").getAttribute("item_count")
      );
      console.log("count ", count);
      const selectors = [
        "cart-drawer-items",
        ".cart-drawer__footer",
        ".drawer__header_wrap",
        ".cart-free-product",
      ];
      $("button.cart__checkout-button").attr("disabled", false);
      if (count > 0) {
        $("cart-drawer").removeClass("is-empty");
        document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
          bubble.classList.remove("hidden");
        });
      } else {
        $("cart-drawer").addClass("is-empty");
        document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
          bubble.classList.add("hidden");
        });
      }
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
      document
        .querySelectorAll(".cart-count-bubble span:first-child")
        .forEach((bubble) => {
          bubble.innerHTML = count;
        });
      console.log("cart drawer reffresh");

      try {
        // window.discountOnCartProApp.updateWidgets();
      } catch (err) {}
    })
    .catch((e) => {
      console.error(e);
    });
};

const removeItems = (productIDS) => {
  console.log(productIDS, "<<<<call removeItems");
  if (productIDS.length) {
    let formData = {
      updates: {},
    };

    var productID;
    for (productID in productIDS) {
      var id = productIDS[productID]?.split("|")[0];
      var qty = productIDS[productID]?.split("|")[1];
      formData["updates"][parseInt(id)] = qty;
    }
    console.log(formData);

    let info = fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        window.refreshCart();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
};

const multipleATC = (data) => {
  var items = [];
  console.log(data);
  data.forEach(function (item) {
    items.push({
      id: item.id,
      quantity: item.quantity,
      properties: item.properties,
    });
  });

  let formData = {
    items: items,
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (response.ok) {
        setTimeout(function () {
          window.refreshCart();
          document.querySelector("#cart-icon-bubble").click();
        }, 0);
        // window.location.href = "/cart";
      }
      return response.json();
    })
    .then((items) => {
      console.log(items);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};
